// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"82765da0","563":"69fc7768","787":"f8aa18c0"}[chunkId] + ".chunk.js";
};